export const namespace = 'customers'
